import { render, staticRenderFns } from "./TodoItemContextMenu.vue?vue&type=template&id=2198c4b9&scoped=true&"
import script from "./TodoItemContextMenu.vue?vue&type=script&lang=js&"
export * from "./TodoItemContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./TodoItemContextMenu.vue?vue&type=style&index=0&id=2198c4b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198c4b9",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/TodoListTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Ftodo-list%2FTodoItemContextMenu.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports